var map = {
	"./ItGoals/1.svg": 445,
	"./ItGoals/2.svg": 446,
	"./ItGoals/3.svg": 447,
	"./ItGoals/4.svg": 448,
	"./ItGoals/courses/ai.png": 606,
	"./ItGoals/courses/computer_literacy.png": 607,
	"./ItGoals/courses/frontend.png": 608,
	"./ItGoals/courses/game_design.png": 609,
	"./ItGoals/courses/gamedev.png": 610,
	"./ItGoals/courses/graphic_design.png": 611,
	"./ItGoals/courses/main.png": 612,
	"./ItGoals/courses/predprinimatelstvo.png": 613,
	"./ItGoals/courses/programming_basics.png": 614,
	"./ItGoals/courses/python.png": 615,
	"./ItGoals/courses/scratch.png": 616,
	"./ItGoals/courses/unity.png": 617,
	"./ItGoals/courses/video_content.png": 618,
	"./ItGoals/courses/videoblogging.png": 619,
	"./ItGoals/courses/web-razrabotka.png": 620,
	"./ItGoals/courses/webdev.png": 621,
	"./ItGoals/coursesNew/ai.png": 494,
	"./ItGoals/coursesNew/computer_literacy.png": 495,
	"./ItGoals/coursesNew/ege-informatika-desk.png": 421,
	"./ItGoals/coursesNew/ege-informatika.png": 422,
	"./ItGoals/coursesNew/frontend.png": 496,
	"./ItGoals/coursesNew/game_design.png": 497,
	"./ItGoals/coursesNew/graphic_design.png": 498,
	"./ItGoals/coursesNew/math-desk.png": 423,
	"./ItGoals/coursesNew/math.png": 424,
	"./ItGoals/coursesNew/predprinimatelstvo.png": 499,
	"./ItGoals/coursesNew/programming_basics.png": 500,
	"./ItGoals/coursesNew/python.png": 501,
	"./ItGoals/coursesNew/scratch.png": 502,
	"./ItGoals/coursesNew/unity.png": 503,
	"./ItGoals/coursesNew/videoblogging.png": 504,
	"./ItGoals/coursesNew/web-razrabotka.png": 505,
	"./ItGoals/cube.svg": 622,
	"./ItGoals/cursor1.svg": 416,
	"./ItGoals/cursor2.svg": 417,
	"./ItGoals/cursor3.svg": 418,
	"./ItGoals/cursor4.svg": 419,
	"./ItGoals/enter.svg": 623,
	"./ItGoals/globe.svg": 624,
	"./ItGoals/outbreak.svg": 625,
	"./ItGoals/puzzle.svg": 626,
	"./ItGoals/story1.png": 627,
	"./ItGoals/story2.png": 628,
	"./ItGoals/story3.png": 629,
	"./PlatformExample/PlatformLogo1.svg": 552,
	"./PlatformExample/PlatformLogo2.svg": 553,
	"./PlatformExample/PlatformLogo3.svg": 554,
	"./PlatformExample/PlatformLogo4.svg": 555,
	"./SK-base.svg": 868,
	"./SK-dark.svg": 869,
	"./achieve-yellow-big.svg": 602,
	"./achieve-yellow-small.svg": 604,
	"./alfa.svg": 870,
	"./application-form-background-mobile.png": 592,
	"./application-form-background.png": 591,
	"./arrowButton.svg": 413,
	"./arrowRight.svg": 755,
	"./components/footer/tg.svg": 550,
	"./components/footer/vk.svg": 548,
	"./components/footer/wa.svg": 549,
	"./components/header/tg.svg": 429,
	"./components/header/vk.svg": 427,
	"./components/header/wa.svg": 428,
	"./cross.svg": 599,
	"./cursor-desk.svg": 603,
	"./cursor-mobile.svg": 605,
	"./detail/ai/6.1.png": 677,
	"./detail/ai/6.2.png": 678,
	"./detail/ai/6.3.png": 679,
	"./detail/ai/6.svg": 525,
	"./detail/ai/7.svg": 509,
	"./detail/ai/line.3.svg": 680,
	"./detail/ai/line.svg": 430,
	"./detail/ai/logoPage.png": 479,
	"./detail/ai/logoPagePhone.png": 464,
	"./detail/ai/spanBorder.svg": 450,
	"./detail/arrow.svg": 507,
	"./detail/computernaya-gramotnost/6.1.png": 681,
	"./detail/computernaya-gramotnost/6.2.png": 682,
	"./detail/computernaya-gramotnost/6.3.png": 683,
	"./detail/computernaya-gramotnost/6.svg": 526,
	"./detail/computernaya-gramotnost/7.svg": 510,
	"./detail/computernaya-gramotnost/line.3.svg": 684,
	"./detail/computernaya-gramotnost/line.svg": 431,
	"./detail/computernaya-gramotnost/logoPage.png": 480,
	"./detail/computernaya-gramotnost/logoPagePhone.png": 465,
	"./detail/computernaya-gramotnost/spanBorder.svg": 451,
	"./detail/ege-informatika/6.1.png": 685,
	"./detail/ege-informatika/6.2.png": 686,
	"./detail/ege-informatika/6.3.png": 687,
	"./detail/ege-informatika/6.svg": 527,
	"./detail/ege-informatika/7.svg": 511,
	"./detail/ege-informatika/line.3.svg": 688,
	"./detail/ege-informatika/line.svg": 432,
	"./detail/ege-informatika/logoPage.png": 481,
	"./detail/ege-informatika/logoPagePhone.png": 466,
	"./detail/ege-informatika/spanBorder.svg": 420,
	"./detail/frontend/6.1.png": 689,
	"./detail/frontend/6.2.png": 690,
	"./detail/frontend/6.3.png": 691,
	"./detail/frontend/6.svg": 528,
	"./detail/frontend/7.svg": 512,
	"./detail/frontend/line.3.svg": 692,
	"./detail/frontend/line.svg": 433,
	"./detail/frontend/logoPage.png": 482,
	"./detail/frontend/logoPagePhone.png": 467,
	"./detail/frontend/spanBorder.svg": 452,
	"./detail/game-design/6.1.png": 693,
	"./detail/game-design/6.2.png": 694,
	"./detail/game-design/6.3.png": 695,
	"./detail/game-design/6.svg": 529,
	"./detail/game-design/7.svg": 513,
	"./detail/game-design/line.3.svg": 696,
	"./detail/game-design/line.svg": 434,
	"./detail/game-design/logoPage.png": 483,
	"./detail/game-design/logoPagePhone.png": 468,
	"./detail/game-design/spanBorder.svg": 453,
	"./detail/graphic-design-pro/6.1.png": 697,
	"./detail/graphic-design-pro/6.2.png": 698,
	"./detail/graphic-design-pro/6.3.png": 699,
	"./detail/graphic-design-pro/6.svg": 530,
	"./detail/graphic-design-pro/7.svg": 514,
	"./detail/graphic-design-pro/line.3.svg": 700,
	"./detail/graphic-design-pro/line.svg": 435,
	"./detail/graphic-design-pro/logoPage.png": 484,
	"./detail/graphic-design-pro/logoPagePhone.png": 469,
	"./detail/graphic-design-pro/spanBorder.svg": 454,
	"./detail/graphic-design/6.1.png": 701,
	"./detail/graphic-design/6.2.png": 702,
	"./detail/graphic-design/6.3.png": 703,
	"./detail/graphic-design/6.svg": 531,
	"./detail/graphic-design/7.svg": 515,
	"./detail/graphic-design/line.3.svg": 704,
	"./detail/graphic-design/line.svg": 436,
	"./detail/graphic-design/logoPage.png": 485,
	"./detail/graphic-design/logoPagePhone.png": 470,
	"./detail/graphic-design/spanBorder.svg": 455,
	"./detail/greenieLike.svg": 705,
	"./detail/intensive/6.1.png": 706,
	"./detail/intensive/6.2.png": 707,
	"./detail/intensive/6.3.png": 708,
	"./detail/intensive/6.svg": 532,
	"./detail/intensive/7.svg": 516,
	"./detail/intensive/line.3.svg": 709,
	"./detail/intensive/line.svg": 437,
	"./detail/intensive/logoPage.png": 486,
	"./detail/intensive/logoPagePhone.png": 471,
	"./detail/intensive/spanBorder.svg": 456,
	"./detail/line-mobile.svg": 508,
	"./detail/line.3.svg": 540,
	"./detail/line.svg": 506,
	"./detail/orangeLight.svg": 710,
	"./detail/osnovy-programmirovaniya/6.1.png": 711,
	"./detail/osnovy-programmirovaniya/6.2.png": 712,
	"./detail/osnovy-programmirovaniya/6.3.png": 713,
	"./detail/osnovy-programmirovaniya/6.svg": 533,
	"./detail/osnovy-programmirovaniya/7.svg": 517,
	"./detail/osnovy-programmirovaniya/line.3.svg": 714,
	"./detail/osnovy-programmirovaniya/line.svg": 438,
	"./detail/osnovy-programmirovaniya/logoPage.png": 487,
	"./detail/osnovy-programmirovaniya/logoPagePhone.png": 472,
	"./detail/osnovy-programmirovaniya/spanBorder.svg": 457,
	"./detail/predprinimatelstvo/6.1.png": 715,
	"./detail/predprinimatelstvo/6.2.png": 716,
	"./detail/predprinimatelstvo/6.3.png": 717,
	"./detail/predprinimatelstvo/6.svg": 534,
	"./detail/predprinimatelstvo/7.svg": 518,
	"./detail/predprinimatelstvo/line.3.svg": 718,
	"./detail/predprinimatelstvo/line.svg": 439,
	"./detail/predprinimatelstvo/logoPage.png": 488,
	"./detail/predprinimatelstvo/logoPagePhone.png": 473,
	"./detail/predprinimatelstvo/spanBorder.svg": 458,
	"./detail/purpleHeart.svg": 719,
	"./detail/python/6.1.png": 720,
	"./detail/python/6.2.png": 721,
	"./detail/python/6.3.png": 722,
	"./detail/python/6.svg": 535,
	"./detail/python/7.svg": 519,
	"./detail/python/line.3.svg": 723,
	"./detail/python/line.svg": 440,
	"./detail/python/logoPage.png": 489,
	"./detail/python/logoPagePhone.png": 474,
	"./detail/python/spanBorder.svg": 459,
	"./detail/scratch/6.1.png": 724,
	"./detail/scratch/6.2.png": 725,
	"./detail/scratch/6.3.png": 726,
	"./detail/scratch/6.svg": 536,
	"./detail/scratch/7.svg": 520,
	"./detail/scratch/line.3.svg": 727,
	"./detail/scratch/line.svg": 441,
	"./detail/scratch/logoPage.png": 490,
	"./detail/scratch/logoPagePhone.png": 475,
	"./detail/scratch/spanBorder.svg": 460,
	"./detail/unity/6.1.png": 728,
	"./detail/unity/6.2.png": 729,
	"./detail/unity/6.3.png": 730,
	"./detail/unity/6.svg": 537,
	"./detail/unity/7.svg": 521,
	"./detail/unity/line.3.svg": 731,
	"./detail/unity/line.svg": 442,
	"./detail/unity/logoPage.png": 491,
	"./detail/unity/logoPagePhone.png": 476,
	"./detail/unity/spanBorder.svg": 461,
	"./detail/videoblogging/6.1.png": 732,
	"./detail/videoblogging/6.2.png": 733,
	"./detail/videoblogging/6.3.png": 734,
	"./detail/videoblogging/6.svg": 538,
	"./detail/videoblogging/7.svg": 522,
	"./detail/videoblogging/line.3.svg": 735,
	"./detail/videoblogging/line.svg": 443,
	"./detail/videoblogging/logoPage.png": 492,
	"./detail/videoblogging/logoPagePhone.png": 477,
	"./detail/videoblogging/spanBorder.svg": 462,
	"./detail/web-razrabotka/6.1.png": 736,
	"./detail/web-razrabotka/6.2.png": 737,
	"./detail/web-razrabotka/6.3.png": 738,
	"./detail/web-razrabotka/6.svg": 539,
	"./detail/web-razrabotka/7.svg": 523,
	"./detail/web-razrabotka/line.3.svg": 739,
	"./detail/web-razrabotka/line.svg": 444,
	"./detail/web-razrabotka/logoPage.png": 493,
	"./detail/web-razrabotka/logoPagePhone.png": 478,
	"./detail/web-razrabotka/spanBorder.svg": 463,
	"./detail/yellowPalms.svg": 740,
	"./egeChildren.png": 590,
	"./firstSteps/1.png": 587,
	"./firstSteps/2.png": 588,
	"./firstSteps/3.png": 589,
	"./firstSteps1.png": 871,
	"./firstSteps2.png": 586,
	"./fotoTestimonialsCustomers.png": 872,
	"./gift1.svg": 565,
	"./gift2.svg": 566,
	"./globe-svg.svg": 449,
	"./globe.png": 873,
	"./green-thumb.png": 639,
	"./greenieLike.svg": 874,
	"./holiday1.svg": 567,
	"./holiday2.svg": 568,
	"./holiday3.svg": 569,
	"./holiday4.svg": 570,
	"./learning/learnGif1.gif": 633,
	"./learning/learnGif2.gif": 634,
	"./learning/learnGif3.gif": 635,
	"./learning/learnGif4.gif": 636,
	"./li/Blue.svg": 643,
	"./li/Green.svg": 644,
	"./li/LightCyan.svg": 645,
	"./li/Lime.svg": 646,
	"./li/NadeshikoPink.svg": 647,
	"./li/Pink.svg": 648,
	"./li/Purple.svg": 649,
	"./li/Sky.svg": 650,
	"./li/SpanishPink.svg": 651,
	"./li/Yellow.svg": 652,
	"./logoAlg.svg": 556,
	"./logoFix.svg": 584,
	"./logoFooter.svg": 600,
	"./logoFooterMobile.svg": 601,
	"./logoHeader.svg": 557,
	"./logoHeaderPc.svg": 558,
	"./logoNavPopUp.svg": 559,
	"./menuNav.svg": 875,
	"./ok.svg": 415,
	"./orangeLight.svg": 876,
	"./ozon.png": 877,
	"./phone.svg": 585,
	"./placeholder.png": 641,
	"./professor/professor1.png": 593,
	"./professor/professor2.png": 594,
	"./professor/professor3.png": 595,
	"./professor/professor4.png": 596,
	"./professor/professor5.png": 597,
	"./professor/professor6.jpg": 598,
	"./purpleHeart.svg": 878,
	"./red-fire.png": 638,
	"./rf.svg": 879,
	"./room/room1.jpg": 880,
	"./room/room2.jpg": 881,
	"./room/room3.jpg": 882,
	"./room/room4.jpg": 883,
	"./sk.svg": 884,
	"./skY.png": 885,
	"./star.svg": 573,
	"./stars.svg": 642,
	"./subtract.svg": 886,
	"./subtract2.svg": 887,
	"./tick.svg": 774,
	"./triangularRight.svg": 951,
	"./violet-heart.png": 637,
	"./yandex.png": 888,
	"./yellow-hello.png": 640,
	"./yellow-line-1-desc.svg": 630,
	"./yellow-line-2-desc.svg": 631,
	"./yellow-line-slider.svg": 632,
	"./yellowPalms.svg": 889
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 867;